export class ReposeGroup {
    groupNo: number;
    id: string;
    name: string;
    vesselId: string;
    description: string;
    channelId: string;
    nonDigitalDataType: NonDigitalDataType;
    nonDigitalValueFlag: NonDigitalValueFlag;
    nonDigitalAlarm: string;
    setPoint: number;
    digitalChannelStatus: number;
    startDelay: number;
    stopDelay: number;
}

export const alarmGroupNameMaxLimit = 28;
export const descriptionMaxLimit = 20;

export interface ReposeGroupFcu {
    [fcuNum: number]: ReposeGroupSetting[];
}

export class ReposeGroupSetting {
    trigger_channel_id: number;
    repose_group_number: number;
    digitalChannelStatus: 0 | 1;
    setPoint: number;
    reposeType: 0 | 1;
    valueReposeType: 0 | 1;
    statusReposeType: AlarmPropertyList;
    ondelay: number;
    offdelay: number;
}

export enum AlarmPropertyList {
    alarmSettingVeryHigh = 'alarmSettingVeryHigh',
    alarmSettingHigh = 'alarmSettingHigh',
    alarmSettingLow = 'alarmSettingLow',
    alarmSettingVeryLow = 'alarmSettingVeryLow',
    alarmSettingSensorFail = 'alarmSettingSensorFail',
    alarmSettingFeedbackError = 'alarmSettingFeedbackError',
    alarmSettingMotor = 'alarmSettingMotor',
    digitalAlarmSetting = 'digitalAlarmSetting',
}

export enum NonDigitalDataType {
    NULL = '',
    VALUE = 'Value',
    STATUS = 'Status',
}

export enum NonDigitalValueFlag {
    NULL = '',
    EXCEED = 'Exceed',
    FALL = 'Fall',
}
